<template>
    <div class="locale-changer">

        <el-select v-model="$i18n.locale"
                   @change="setLanguage">
            <el-option v-for="(lang, i) in langs"
                    :key="`Lang${i}`"
                    :value="lang"
                    :label="lang">
            </el-option>
        </el-select>

    </div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';
    import { languageService } from '@/services/languageService'
    import { useUserStore } from '@/stores/userStore';

    export default defineComponent({
        data() {
            return {
                langs: languageService.getLanguages(),
                userStore: useUserStore()
            }
        },

        methods: {
            async setLanguage(newVal: any) {
                await this.userStore.setLanguage(newVal);
                this.$router.go(0);
            }
        }
    })

</script>

<style scoped>

    .locale-changer{
        width: 65px;
    }

</style>